export default {
  'app.settings.menuMap.basic': 'Configuració bàsica',
  'app.settings.menuMap.security': 'Configuració de seguretat',
  'app.settings.menuMap.binding': 'Vinculació de compte',
  'app.settings.menuMap.notification': 'Notificacions de missatges nous',
  'app.settings.basic.avatar': 'Avatar',
  'app.settings.basic.change-avatar': 'Canviar avatar',
  'app.settings.basic.email': 'Correu electrònic',
  'app.settings.basic.email-message': 'Introduïu el vostre correu electrònic!',
  'app.settings.basic.nickname': 'Sobrenom',
  'app.settings.basic.nickname-message': 'Introduïu el vostre sobrenom!',
  'app.settings.basic.profile': 'Descripció personal',
  'app.settings.basic.profile-message': 'Introduïu la descripció personal!',
  'app.settings.basic.profile-placeholder': 'Descripció personal',
  'app.settings.basic.country': 'País/Regió',
  'app.settings.basic.country-message': 'Introduïu el vostre país o regió!',
  'app.settings.basic.geographic': 'Província/Ciutat',
  'app.settings.basic.geographic-message': 'Introduïu la vostra província o ciutat!',
  'app.settings.basic.address': 'Adreça del carrer',
  'app.settings.basic.address-message': 'Introduïu la vostra adreça del carrer!',
  'app.settings.basic.phone': 'Telèfon de contacte',
  'app.settings.basic.phone-message': 'Introduïu el vostre telèfon de contacte!',
  'app.settings.basic.update': 'Actualitzar informació bàsica',
  'app.settings.security.strong': 'Fort',
  'app.settings.security.medium': 'Mitjà',
  'app.settings.security.weak': 'Feble',
  'app.settings.security.password': 'Contrasenya del compte',
  'app.settings.security.password-description': 'Força actual de la contrasenya',
  'app.settings.security.phone': 'Telèfon de seguretat',
  'app.settings.security.phone-description': 'Telèfon vinculat',
  'app.settings.security.question': 'Pregunta de seguretat',
  'app.settings.security.question-description':'No s\'ha establert una pregunta de seguretat. Les preguntes de seguretat poden protegir eficaçment la seguretat del compte',
  'app.settings.security.email': 'Correu electrònic de reserva',
  'app.settings.security.email-description': 'Correu electrònic vinculat',
  'app.settings.security.mfa': 'Dispositiu MFA',
  'app.settings.security.mfa-description':'No s\'ha vinculat cap dispositiu MFA. Un cop vinculat, es pot fer una confirmació secundària',
  'app.settings.security.modify': 'Modificar',
  'app.settings.security.set': 'Configurar',
  'app.settings.security.bind': 'Vincular',
  'app.settings.binding.taobao': 'Vincular Taobao',
  'app.settings.binding.taobao-description': 'Actualment no hi ha cap compte Taobao vinculat',
  'app.settings.binding.alipay': 'Vincular Alipay',
  'app.settings.binding.alipay-description': 'Actualment no hi ha cap compte Alipay vinculat',
  'app.settings.binding.dingding': 'Vincular DingTalk',
  'app.settings.binding.dingding-description': 'Actualment no hi ha cap compte DingTalk vinculat',
  'app.settings.binding.bind': 'Vincular',
  'app.settings.notification.password': 'Contrasenya del compte',
  'app.settings.notification.password-description':'Els missatges d\'altres usuaris es notificaran en forma de missatges interns',
  'app.settings.notification.messages': 'Missatges del sistema',
  'app.settings.notification.messages-description':'Els missatges del sistema es notificaran en forma de missatges interns',
  'app.settings.notification.todo': 'Tasques pendents',
  'app.settings.notification.todo-description': 'Les tasques pendents es notificaran en forma de missatges interns',
  'app.settings.open': 'Activat',
  'app.settings.close': 'Desactivat',
};
